module.exports = __webpack_public_path__ + "static/media/tallBg.6fb865b6.png";